import { render, staticRenderFns } from "./BecomeLeader.vue?vue&type=template&id=6a115492&scoped=true&"
import script from "./BecomeLeader.vue?vue&type=script&lang=js&"
export * from "./BecomeLeader.vue?vue&type=script&lang=js&"
import style0 from "./BecomeLeader.vue?vue&type=style&index=0&id=6a115492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a115492",
  null
  
)

export default component.exports